import { render, staticRenderFns } from "./_pageNumber.vue?vue&type=template&id=165e5a14&"
import script from "./_pageNumber.vue?vue&type=script&lang=ts&"
export * from "./_pageNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogListPost: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/BlogListPost.vue').default,CommonPagination: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonPagination.vue').default})
